import { Ban, CheckCircle2, LucideIcon, XCircle } from 'lucide-react'
import { ProposalFinalState, ProposalRejectedBy } from '../types/maintenanceManualEntryProposal.type'

export const proposalFinalStateLabel: Record<ProposalFinalState, string> = {
  accepted: 'Aceita',
  rejected: 'Rejeitada',
  cancelled: 'Cancelada',
}

export const proposalFinalStateIcon: Record<ProposalFinalState, LucideIcon> = {
  accepted: CheckCircle2,
  rejected: XCircle,
  cancelled: Ban,
}

export const proposalFinalStateBannerClass: Record<ProposalFinalState, string> = {
  accepted: 'bg-success-op/40 text-valid',
  rejected: 'bg-danger-soft/15 text-danger-soft',
  cancelled: 'bg-white-200 text-white-400',
}

export const proposalFinalStateAccentClass: Record<ProposalFinalState, string> = {
  accepted: 'bg-success',
  rejected: 'bg-danger-soft',
  cancelled: 'bg-white-300',
}

export const proposalRejectedByLabel: Record<ProposalRejectedBy, string> = {
  establishment: 'Você rejeitou',
  client: 'Cliente rejeitou',
}
